<template>
    <!-- The same page furniture as every step of the funnel, so a failure does not look like
         leaving it. The business surfaces get the business terms in the footer. -->
    <div class="flex min-h-screen flex-col bg-white">
        <CheckoutHeader :business="business" />

        <main class="flex flex-1 items-center justify-center px-6 py-16">
            <div class="max-w-md text-center">
                <p class="text-slate-500 font-inter text-sm uppercase tracking-wide">Error {{ error.statusCode }}</p>
                <h1 class="mt-2 text-slate-700 font-inter font-bold text-2xl">Something went wrong</h1>
                <p class="mt-4 text-slate-600">{{ error.message }}</p>
                <button
                    class="mt-8 inline-flex items-center justify-center rounded-md bg-blue-600 px-6 py-3 text-white-700 font-inter font-semibold text-sm"
                    @click="handleError"
                >
                    Try Again
                </button>
            </div>
        </main>

        <CheckoutFooter :business="business" />
    </div>
</template>

<script setup lang="ts">
import CheckoutFooter from '~/components/checkout/CheckoutFooter.vue';
import CheckoutHeader from '~/components/checkout/CheckoutHeader.vue';

defineProps<{ error: { statusCode: number; message: string } }>();

// The error page sits outside every page, so the route is all it knows of who was buying.
const business = /^\/(business|proposal)(\/|$)/.test(useRoute().path);

const handleError = () => clearError({ redirect: '/' });
</script>
